import { TypedDocumentNode, gql } from '@apollo/client';
import { defineMessages } from 'react-intl';

import { Switch } from 'atoms/inputs/Switch';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useMutation } from 'hooks/graphql/useMutation';

import { SettingsSection } from '../SettingsSection';
import {
  UpdateUserSettingsDiscoverableMutation,
  UpdateUserSettingsDiscoverableMutationVariables,
} from './__generated__/index.graphql';

const messages = defineMessages({
  title: {
    id: 'Settings.Privacy.Discoverable.title',
    defaultMessage: 'Discoverability',
  },
  description: {
    id: 'Settings.Privacy.Discoverable.description',
    defaultMessage:
      'if this is turned on people will be able to find you through their contacts.',
  },
});

const UPDATE_USER_SETTINGS_MUTATION = gql`
  mutation UpdateUserSettingsDiscoverableMutation(
    $input: updateUserSettingsInput!
  ) {
    updateUserSettings(input: $input) {
      userSettings {
        id
        discoverable
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserSettingsDiscoverableMutation,
  UpdateUserSettingsDiscoverableMutationVariables
>;

export const DiscoverableSetting = () => {
  const { currentUser } = useCurrentUserContext();
  const discoverable = currentUser?.userSettings?.discoverable;
  const [updateUserSettings] = useMutation(UPDATE_USER_SETTINGS_MUTATION);

  const setDiscoverableSettings = async () =>
    updateUserSettings({
      variables: { input: { discoverable: !discoverable } },
    });

  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={discoverable || false}
          onChange={setDiscoverableSettings}
        />
      }
    />
  );
};
